<template>
    <div class="formulario-endereco">
        <div class="row">
            <div class="col s12 m12">
                <label for="endereco" class="active">{{ titulo }}</label>
                <gmap-input
                    :id="id"
                    :field-name="'endereco'"
                    :end="enderecoString"
                    :latitude="'0'"
                    :longitude="'0'"
                    @newgmapdatacomplete="handleDataGmap($event)">
                </gmap-input>
            </div>
        </div>
    </div>
</template>
<script>
    import MaskedInput from 'vue-masked-input';
    import GmapInput from '../common/GmapInput.vue';

    export default {
        components: {
            MaskedInput,
            GmapInput
        },
        props: ['endereco', 'title', 'id'],
        data: () => ({
            formData: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            titulo: 'Endereço',
            enderecoString: ''
        }),
        created() {
            if (this.title) {
                this.titulo = this.title;
            }
            if (this.endereco) {
                this.formData.endereco_cep = this.endereco.endereco_cep;
                this.formData.endereco_estado = this.endereco.endereco_estado;
                this.formData.endereco_cidade = this.endereco.endereco_cidade;
                this.formData.endereco_bairro = this.endereco.endereco_bairro;
                this.formData.endereco_logradouro = this.endereco.endereco_logradouro;
                this.formData.endereco_numero = this.endereco.endereco_numero;
                this.formData.endereco_complemento = this.endereco.endereco_complemento;
            }

            if(this.formData.endereco_logradouro){
                this.enderecoString = this.checkReturn(this.formData.endereco_logradouro)+' ' +
                    ''+this.checkReturn(this.formData.endereco_numero)+' ' +
                    ''+this.checkReturn(this.formData.endereco_complemento)+' ' +
                    ''+this.checkReturn(this.formData.endereco_bairro)+' ' +
                    ''+this.checkReturn(this.formData.endereco_cidade)+' ' +
                    ''+this.checkReturn(this.formData.endereco_estado)

            }
        },
        watch: {
            formData: {
                handler: function() {
                    this.$emit('newdata', [
                        this.formData.endereco_cep,
                        this.formData.endereco_estado,
                        this.formData.endereco_cidade,
                        this.formData.endereco_bairro,
                        this.formData.endereco_logradouro,
                        this.formData.endereco_numero,
                        this.formData.endereco_complemento
                    ]);

                    this.$emit('input', this.formData)
                },
                deep: true
            }
        },
        methods: {
            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },
            handleDataGmap(e) {
                [
                    this.formData.endereco_logradouro,
                    this.formData.endereco_numero,
                    this.formData.endereco_cep,
                    this.formData.endereco_estado,
                    this.formData.endereco_bairro,
                    this.formData.endereco_cidade
                ] = e;
            },
            checkReturn(string) {
                if (string) {
                    return string;
                }
                return '';
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/common/FormularioEndereco.vue